import { CourseDocumentApi, courseDocumentsApi } from "api/courseDocumentsApi";
import { useEffect, useState } from "react";

export const useCourseDocument = (courseId: number, courseDocumentId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<CourseDocumentApi | null>(null);

  const fetchResource = async () => {
    if (!courseId || !courseDocumentId) {
      console.error("Course id not found.");
      setLoading(false);
      return;
    }
    const res = await courseDocumentsApi.fetchById(courseId, courseDocumentId);
    try {
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResource();
  }, [courseId, courseDocumentId]);

  return { loading, data, refresh: fetchResource };
};
